import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/managefeedetail/page', Object.assign({}, options, { params }));

  export const getCarparkingSpaceFeeDetailList = (params, options) =>
  request.get('/api/v4ward/car/carparkingSpaceFeeDetail/page', Object.assign({}, options, { params }));

  export const getRegionList = (params, options) =>
  request.get('/api/v4ward/car/ParkSpace/getRegionList', Object.assign({}, options, { params }));
  
  export const getSpaceList = (params, options) =>
  request.get('/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode/v2?id=0', Object.assign({}, options, { params }));
  
// export const getDetail = (params, options) =>
//   request.get('/api/v4ward/pay/payChannel/detail', Object.assign({}, options, { params }));

// export const remove = (params, options) =>
//   request.post('/api/v4ward/pay/payChannel/remove', qs.stringify(params), options);

// export const add = (params, options) =>
//   request.post('/api/v4ward/pay/payChannel/submit', params, options);

// export const update = (params, options) =>
//   request.post('/api/v4ward/pay/payChannel/submit', params, options);
